import React, { useEffect, useState } from 'react';

import { setStepUpResolver } from '~/repositories/client/Client';
import { StepUpChallenge } from '~/repositories/StepUpRepository';
import { useStepUpStore } from '~/stores/StepUp';

import { StepUpDialog } from './StepUpDialog';

// Mounted once at the app root; renders the step-up challenge dialog whenever any API call is rejected
// with step_up_auth_required (intercepted globally in both HTTP clients).
export const StepUpDialogHost = () => {
  const { challenge, isVerifying, submit, submitPasskey, resend, cancel } = useStepUpStore();
  const [layer] = useState(() => {
    const element = document.createElement('div');
    element.dataset.slot = 'step-up-layer';
    element.style.position = 'relative';
    element.style.zIndex = 'var(--z-step-up)';
    element.style.pointerEvents = 'auto';
    return element;
  });

  useEffect(() => {
    document.body.appendChild(layer);
    return () => layer.remove();
  }, [layer]);

  // The legacy repository client cannot import the store without an import cycle
  // (store -> StepUpRepository -> client), so it consumes the resolver via a registry;
  // registering on mount keeps the wiring tied to the dialog actually being available.
  useEffect(() => {
    setStepUpResolver(() => useStepUpStore.getState().requireStepUp());
  }, []);

  return (
    <StepUpDialog
      isOpen={challenge !== null}
      challenge={challenge}
      isLoading={isVerifying}
      onSubmit={(proof) => (proof.passkey ? submitPasskey() : submit(proof))}
      onResend={challenge === StepUpChallenge.MfaSms ? resend : undefined}
      onClose={cancel}
      container={layer}
    />
  );
};
